var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dataText!='')?_c('dr-column',{class:_vm.isPageCenter?'no-data':'',attrs:{"justifyContent":"center","alignItems":"center"}},[_c('van-image',{attrs:{"src":_vm.imgs,"width":"87"}}),_vm._v(" "),_c('div',{staticClass:"no-data-text"},[_vm._v(_vm._s(_vm.dataText))])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cc72603c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/noData/index.vue
// module id = null
// module chunks = 